"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
exports.createMuiButtonOverrides = function (_a) {
    var _b, _c;
    var palette = _a.palette, spacing = _a.spacing, breakpoints = _a.breakpoints, transitions = _a.transitions, typography = _a.typography;
    return ({
        root: (_b = {
                minWidth: spacing(30),
                minHeight: spacing(10),
                padding: spacing(1, 3),
                border: "2px solid transparent",
                transition: transitions.create(["background-color", "border", "opacity", "padding"], { duration: transitions.duration.short }),
                "&:hover": {
                    backgroundColor: undefined,
                },
                "&:active": {
                    opacity: 0.85,
                },
                "&$disabled": {
                    color: undefined,
                    opacity: 0.3,
                }
            },
            _b[breakpoints.only("xl")] = {
                padding: spacing(3),
                minWidth: spacing(50),
                minHeight: spacing(12),
            },
            _b),
        focusVisible: {
            "&$contained, &$text": {
                borderColor: colorManipulator_1.fade(palette.text.primary, palette.type === "dark" ? 0.5 : 0.6),
            },
        },
        contained: {
            "&$disabled": {
                color: undefined,
                backgroundColor: undefined,
            },
        },
        containedPrimary: {
            "&:hover": {
                backgroundColor: colorManipulator_1.lighten(palette.primary.main, 0.2),
            },
            "&:active": {
                backgroundColor: palette.primary.main,
            },
            "&$focusVisible": {
                borderColor: colorManipulator_1.fade(palette.common.white, 0.5),
            },
        },
        containedSecondary: {
            "&:hover": {
                backgroundColor: palette.type === "dark"
                    ? colorManipulator_1.fade(palette.common.white, 0.28)
                    : colorManipulator_1.fade(palette.common.black, 0.04),
            },
            "&:active": {
                opacity: palette.type === "light" ? 0.6 : undefined,
                backgroundColor: palette.secondary.main,
            },
        },
        outlined: {
            "&$disabled": {
                border: undefined,
            },
        },
        outlinedPrimary: {
            border: undefined,
            borderColor: palette.primary.main,
            color: palette.text.primary,
            "&:hover": {
                border: undefined,
                backgroundColor: colorManipulator_1.fade(palette.primary.main, 0.2),
            },
            "&:active": {
                backgroundColor: "transparent",
            },
            "&&$focusVisible": {
                borderColor: palette.primary.main,
                boxShadow: "inset 0 0 0 3px " + colorManipulator_1.fade(palette.text.primary, palette.type === "dark" ? 0.5 : 0.6),
            },
        },
        outlinedSecondary: {
            color: palette.secondary.contrastText,
            borderColor: palette.divider,
            "&:hover": {
                border: undefined,
                borderColor: palette.secondary.contrastText,
                backgroundColor: undefined,
            },
            "&:active": {
                borderColor: palette.secondary.contrastText,
                backgroundColor: palette.secondary.main,
            },
            "&&$focusVisible": {
                borderColor: colorManipulator_1.fade(palette.text.primary, palette.type === "dark" ? 0.5 : 0.6),
                backgroundColor: palette.secondary.main,
            },
            "&$disabled": {
                border: undefined,
            },
        },
        textPrimary: {
            color: palette.text.primary,
            "&:hover": {
                backgroundColor: colorManipulator_1.fade(palette.common.white, 0.2),
            },
            "&:active": {
                backgroundColor: "transparent",
            },
        },
        sizeSmall: (_c = {
                minWidth: 0,
                minHeight: spacing(6),
                padding: "3px " + spacing(2) + "px",
                "&&": {
                    flexGrow: 0,
                    fontSize: typography.pxToRem(9),
                },
                "&:active": {
                    opacity: 0.85,
                }
            },
            _c[breakpoints.only("xl")] = {
                fontSize: typography.pxToRem(11),
            },
            _c),
    });
};
//# sourceMappingURL=MuiButton.js.map